import { createAsyncThunk } from '@reduxjs/toolkit';

import { getHttpClient } from '../../../http/httpClientManager';

export type Profile = {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  avatarUrl: string | null;
  location: string | null;
  phone: string | null;
  isSuperAdmin: boolean;
};

export type MembershipRole = 'owner' | 'admin' | 'viewer';

export type Membership = {
  clientId: string;
  client: string;
  clientName: string;
  logoUrl?: string;
  role: MembershipRole;
};

// Parent tenant grouping several clients — scopes the portfolio builder.
export type Tenant = {
  id: string;
  slug: string;
  name: string;
  logoUrl: string | null;
  clientSlugs: string[];
};

export type ProfilePayload = {
  profile: Profile;
  memberships: Membership[];
  tenants: Tenant[];
};

export const fetchTenantsData = createAsyncThunk<ProfilePayload, void>(
  'app/fetchTenantsData',
  async () => {
    const res = await getHttpClient('api').get<ProfilePayload>('/api/v1/profile');
    return res.data;
  },
);
